import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface GetROParams {
    report_id?: string;
}

export enum ReportStatus {
    SUBMITTED = "SUBMITTED",
    IN_PROGRESS = "IN_PROGRESS",
    AVAILABLE = "AVAILABLE",
    FAILED = "FAILED",
}

export interface ROReport {
    report_id: string;
    party_id: string;
    content?: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface ReasonedOrdersResponse {
    ro_reports: ROReport[];
}

export interface GenerateRORequest {
    party_id: string;
    report_id: string;
}

export interface UpsertRORequest {
    party_id: string;
    content: string;
}

export const LegacyReasonedOrderAPI = {
    get_reasoned_orders: async (
        { case_id, report_id }: { case_id: string } & GetROParams
    ) => {
        const response: AxiosResponse<ReasonedOrdersResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/reports/reasoned-order`,
                report_id ? { params: { report_id } } : undefined
            );

        return response.data;
    },

    create_reasoned_order: async (
        case_id: string,
        request: GenerateRORequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.post(
                `v1/cases/${case_id}/reports/reasoned-order`,
                request
            );

        return response.data;
    },

    upsert_reasoned_order: async (
        case_id: string,
        report_id: string,
        request: UpsertRORequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${case_id}/reports/reasoned-order/${report_id}`,
                request
            );

        return response.data;
    },
};

export const ReasonedOrderAPI = {
    get_ro_reports: async (
        { case_id, report_id }: { case_id: string } & GetROParams
    ) => {
        const response: AxiosResponse<ReasonedOrdersResponse> =
            await axiosInstance.get(
                `v1/cases/${case_id}/ro-reports`,
                report_id ? { params: { report_id } } : undefined
            );

        return response.data;
    },

    generate_ro_report: async (
        case_id: string,
        request: GenerateRORequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.post(
                `v1/cases/${case_id}/ro-reports/generate`,
                request
            );

        return response.data;
    },

    upsert_ro_report: async (
        case_id: string,
        report_id: string,
        request: UpsertRORequest
    ): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> =
            await axiosInstance.put(
                `v1/cases/${case_id}/ro-reports/${report_id}`,
                request
            );

        return response.data;
    },
};